import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Button, Table,
	Modal, message, Select, Typography, Tooltip, Pagination, Tag,
} from 'antd';
import {
	PlusOutlined, FormOutlined, CloseSquareOutlined,
	ExclamationCircleOutlined, SettingOutlined, RedoOutlined,
	RiseOutlined, BankOutlined,
} from '@ant-design/icons';

import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Target Pendapatan',
	apiUrl: { data: 'master/api/target-pendapatan/' },
	pageUrl: { form: '/admin/pengaturan/target-pendapatan/form/' },
	breadCrumb: [
		<span><SettingOutlined /> Pengaturan</span>,
		'Target Pendapatan',
	],
};

const config = new Config();
const rp = v => 'Rp ' + (v || 0).toLocaleString('id-ID');

class DataTargetPendapatan extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errMsg: '',
			errTitle: '',
			loadingData: false,
			loadingButton: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			filterTahun: new Date().getFullYear(),
			dataSource: [],
			isMobile: window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Konfirmasi Hapus?',
			icon: <ExclamationCircleOutlined />,
			content: 'Yakin menghapus data target pendapatan ini?',
			okText: 'Ya', okType: 'danger', cancelText: 'Tidak',
			onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Memproses...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				this.setState({ loadingButton: false });
				if (this.props.isSuccess) {
					message.success({ content: 'berhasil menghapus data', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'gagal menghapus data', duration: 2, key: 'toast' });
					this.setState({ errMsg: this.props.responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'kesalahan pengiriman data', duration: 2, key: 'toast' });
			});
	}

	async getData(limit = this.state.pagination.pageSize, offset = 0) {
		this.setState({ loadingData: true });
		const { filterTahun } = this.state;
		let url = configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset;
		if (filterTahun) url += '&tahun=' + filterTahun;

		this.props.ajaxViewHandler('get', url)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					this.setState(prev => ({
						dataSource: data.results,
						pagination: { ...prev.pagination, total: data.count },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'error get data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'gagal request data', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	handleTableChange = (pagination) => {
		this.setState({
			pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current },
		});
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	_buildColumns() {
		return [
			{
				title: 'No',
				key: 'no',
				width: 56,
				align: 'center',
				render: (_, __, index) => {
					const { pagination } = this.state;
					return (
						<Text style={{ fontSize: 12, color: '#888' }}>
							{(pagination.current - 1) * pagination.pageSize + index + 1}
						</Text>
					);
				},
			},
			{
				title: 'Tahun',
				dataIndex: 'tahun',
				key: 'tahun',
				width: 100,
				align: 'center',
				render: (value) => (
					<Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a' }}>
						{value}
					</Tag>
				),
			},
			{
				title: 'Kabupaten/Kota',
				dataIndex: 'kabupaten_nama',
				key: 'kabupaten_nama',
				render: (value) => value ? (
					<div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
						<BankOutlined style={{ color: '#1890ff', fontSize: 13 }} />
						<Text style={{ fontSize: 13 }}>{value}</Text>
					</div>
				) : <Text type="secondary" italic>Semua Kabupaten</Text>,
			},
			{
				title: 'Target PKB',
				dataIndex: 'target_pkb',
				key: 'target_pkb',
				align: 'right',
				render: (val) => rp(val),
			},
			{
				title: 'Target BBNKB',
				dataIndex: 'target_bbnkb',
				key: 'target_bbnkb',
				align: 'right',
				render: (val) => rp(val),
			},
			{
				title: 'Target Total',
				dataIndex: 'target_total',
				key: 'target_total',
				align: 'right',
				render: (val) => <strong style={{ color: '#1e4d8a' }}>{rp(val)}</strong>,
			},
			{
				title: 'Aksi',
				key: 'aksi',
				width: 90,
				fixed: 'right',
				align: 'center',
				render: (_, row) => (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Link to={configClass.pageUrl.form + row.id}>
							<Tooltip title="Edit">
								<Button size="small" shape="circle" type="primary" ghost>
									<FormOutlined />
								</Button>
							</Tooltip>
						</Link>
						<Tooltip title="Hapus">
							<Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}>
								<CloseSquareOutlined />
							</Button>
						</Tooltip>
					</div>
				),
			},
		];
	}

	renderMobileCard(row) {
		return (
			<Card
				key={row.id}
				style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }}
				bodyStyle={{ padding: 0 }}
			>
				<div style={{
					background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
					borderBottom: '1px solid #d0dff5',
					padding: '12px 16px',
					display: 'flex', alignItems: 'center', gap: 12,
				}}>
					<div style={{
						width: 44, height: 44, borderRadius: 12,
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
					}}>
						<RiseOutlined style={{ color: '#fff', fontSize: 20 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 15, color: '#0f2847', lineHeight: 1.3 }}>
							Tahun {row.tahun}
						</div>
						<div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
							{row.kabupaten_nama || 'Semua Kabupaten'}
						</div>
					</div>
				</div>
				<div style={{ padding: '10px 16px' }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
						<Text type="secondary" style={{ fontSize: 12 }}>Target PKB</Text>
						<Text style={{ fontSize: 12 }}>{rp(row.target_pkb)}</Text>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
						<Text type="secondary" style={{ fontSize: 12 }}>Target BBNKB</Text>
						<Text style={{ fontSize: 12 }}>{rp(row.target_bbnkb)}</Text>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
						<Text type="secondary" style={{ fontSize: 12 }}>Target Total</Text>
						<Text strong style={{ fontSize: 12, color: '#1e4d8a' }}>{rp(row.target_total)}</Text>
					</div>
					<div style={{ display: 'flex', gap: 6 }}>
						<Link to={configClass.pageUrl.form + row.id} style={{ flex: 1 }}>
							<Button block size="small" icon={<FormOutlined />}>Edit</Button>
						</Link>
						<Button block size="small" danger icon={<CloseSquareOutlined />} style={{ flex: 1 }} onClick={() => this.showDeleteConfirm(row.id)}>Hapus</Button>
					</div>
				</div>
			</Card>
		);
	}

	render() {
		const { errMsg, loadingData, dataSource, pagination, isMobile, filterTahun } = this.state;

		const tahunNow = new Date().getFullYear();
		const tahunOptions = [];
		for (let y = tahunNow + 2; y >= tahunNow - 3; y--) {
			tahunOptions.push(<Select.Option key={y} value={y}>{y}</Select.Option>);
		}

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.data-targetpendapatan-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700;
							font-size: 13px;
							color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.data-targetpendapatan-wrap .ant-table-tbody > tr > td {
							padding: 12px 16px;
							vertical-align: middle;
						}
						.data-targetpendapatan-wrap .ant-table-tbody > tr:hover > td {
							background: #e8f0fb !important;
						}
						.data-targetpendapatan-wrap .ant-table-tbody > tr:nth-child(even) > td {
							background: #fafafa;
						}
						.data-targetpendapatan-wrap .ant-table-tbody > tr:nth-child(even):hover > td {
							background: #e8f0fb !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title="Error"
					error={errMsg}
					onClose={() => this.setState({ errMsg: '' })}
				/>

				<Card
					className="data-targetpendapatan-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* Header */}
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<RiseOutlined style={{ marginRight: 8 }} />
								{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} target terdaftar
								{loadingData && ' · Memuat...'}
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data">
								<Button
									onClick={() => this.getData()}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
							<Link to={configClass.pageUrl.form}>
								<Button
									type="primary"
									icon={<PlusOutlined />}
									style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
								>
									{isMobile ? 'Tambah' : 'Tambah Target'}
								</Button>
							</Link>
						</div>
					</div>

					{/* Filter bar */}
					<div style={{
						padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
					}}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
						<Select
							style={{ width: 140, borderRadius: 8 }}
							placeholder="Tahun"
							value={filterTahun}
							onChange={val => this.setState({ filterTahun: val }, () => this.getData())}
							allowClear
						>
							{tahunOptions}
						</Select>
					</div>

					{/* Konten */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
								) : dataSource.length === 0 ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
								) : (
									dataSource.map(row => this.renderMobileCard(row))
								)}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current}
											pageSize={pagination.pageSize}
											total={pagination.total}
											onChange={this.handleMobilePageChange}
											showSizeChanger={false}
											simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = state => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(DataTargetPendapatan);
